import React from "react";
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {
  disabled?: boolean;
};

const SwapBoxButton = ({ disabled = false }: Props) => {
  const { onOpenSwapBoxModalHandler } = useConveyorBoxHandlers();
  return (
    <Button
      content="Byt låda"
      size="big"
      aria-label="byt låda"
      icon="exchange"
      onClick={onOpenSwapBoxModalHandler}
      disabled={disabled}
    />
  );
};

export default SwapBoxButton;
